module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAlBAMAAAD2N3ecAAAAGFBMVEUAAADS0tLa2trT09Ps7OzX19fo6Oji4uJKfQTtAAAAAXRSTlMAQObYZgAAAQhJREFUKM+lkkFPwzAMhatJ+wGpVbguW8Xdi7o7mgnXVWPjzMh2p5T9flynUiNH5cJ3yJPy/JzEbfEPujWzyvcXaJgyN6wRDlnARKqZAOrIAlEMSCMb52Aoln10AxJbmgmAqGXSnXGSE1aJUfZEHas2XPC3G33miTffnbZ3apUBFV25uOlfQCUeXo98MJ69blVfeEGoQqta9d/xCqJpwm+M8PSsjfE659yIM9ztZxK7JCGV3s6cESyK1h/6HT8iVbDZy0UePSijoS95516PBGseFryTVcYwJd/d6QrKAIPbQHTB/EOhgdORdTLaschFSRKxbbpGY2lw7DXRFAOt0cAh/rfrjOIPfgGYZUuQy7WiKwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/icon_no-photo_48x37.png
// module id = 77
// module chunks = 0